export default {
  containerStyle: {
    display: "flex",
    flexWrap: "wrap" as "wrap",
  },
};
